<template>
    <div class="py-4 container-fluid">
        <div v-if="!isLoading" class="row">
            <div class=" row">
                <div class="col-12">
                    <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlert">
                        <strong>Comentario!</strong> Eliminado correctamente!
                    </argon-alert>
                    <comment-table :comments="comments" />
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import CommentTable from "./components/CommentTable.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
    name: "comments",
    components: {
        CommentTable,
        ArgonAlert
    },
    data() {
        return {
            isLoading: true,
            comments: undefined,
            showAlert: false,
        };
    },
    created() {
        this.plain
            .get(`/comments`)
            .then((response) => {
                // console.log("RESPONSE NUM COMMENTS");
                // console.log(response.data);
                if (response.data.length !== 0) this.comments = response.data;
                else this.comments = [];
                this.isLoading = false;
                // console.log("RESPONSE COMMENTS");
                // console.log(this.comments);
            })
            .catch((err) => {
                this.comments = [];
                this.isLoading = false;
                console.log(err);
            });
    },
    methods: {
        deleteItemComment(commentID) {
            this.showAlert = true;
            this.comments = this.comments.filter(({ id }) => id !== commentID);
            // console.log("COMMENTS COMMENTS COMMENTS");
            // console.log(this.comments);
            window.scrollTo(0, 0);
            this.plain.delete(`/comments/${commentID}`)
                .then(() => {
                    // console.log("Comentario eliminado de la base de datos");
                })
                .catch((error) => {
                    console.log("Error al eliminar comentario de la base de datos", error);
                });

        },
        closeAlert() {
            this.showAlert = false;
        },
    },
};
</script>
